{
  "negative": "Error",
  "notice": "Warning",
  "info": "Information",
  "positive": "Success"
}
